import { DiagnosticModel } from './diagnostic.model';
import { IndicateurModel } from './indicateur.model';
import { AnswerModel } from './answer.model';



export class SimpleAnswerModel
{
	id: number = undefined;
	evolution:number = undefined;
	gravity:string = undefined;
	score:null = undefined;
	revelent:number = undefined;
	freetext:string = undefined;
	freephoto:string = undefined;

	diagnostic:DiagnosticModel = new DiagnosticModel({});
	indicator:IndicateurModel = new IndicateurModel({});

	
	get slice()
	{
		return this.diagnostic.questionnary.getSlice(this.score);
	}



	constructor(values) {
		this.exchange(values, false);
	}
	
	exchange(values: Object = {}, isObject=false) {
	    for (let p in values) {
	    	
		    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
		    	else {
		    		if(isObject) this[p].exchange(values[p]);
		    		else this[p] = values[p];
		    	} 
		    }
	    	else if(p=='_embedded') {
	    		this.setEmbedded(values[p]);
				this.indicator.answer = new AnswerModel(values);
	    	}
		}
	}

	setEmbedded(values)
	{
		if(values.diagnostic) this.diagnostic.exchange(values.diagnostic);
		if(values.indicator) this.indicator.exchange(values.indicator);
	}
}